import { createClient } from 'contentful';

const SPACE_ID = '3fn1lqe7l5ub'
const ACCESS_TOKEN = '6bc7cfdcf3d9113bd38c2c81ba16a63ad6928c745ee3d2983c11ffd1c6dd51b4'

const client = createClient({
    space: SPACE_ID,
    accessToken: ACCESS_TOKEN
})


export default client;


// WEBPACK FOOTER //
// ./src/Services/client.js